import App from 'app/app.js';

function LtCheckboxDirective() {
  return {
    restrict: 'E',
    scope: {
      ltId: '@', // ID to use on input field, label should have this in it's for att
      ltLabelId: '@', // ID of the label this belongs to
      ltNgModel: '=' // ng-model data
    },
    // aria labels for accessibility https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/checkbox_role
    template:
      '   <input type="checkbox" id="{{ltId}}" ng-model="ltNgModel" hidden="hidden" aria-hidden="true"/>' +
      '   <span class="lt-checkbox"' +
      '         ng-click="toggleValue()"' +
      '         ng-keypress="onKeypress($event)"' +
      '         role="checkbox"' +
      '         aria-checked="{{ltNgModel}}"' +
      '         aria-labelledby="{{ltLabelId}}"' +
      '         tabindex="0">' +
      '       <lt-icon name="fa-sharp-solid-check" aria-hidden="true" ng-show="ltNgModel"></lt-icon>' +
      '   </span>',
    link: function (scope) {
      scope.toggleValue = function () {
        scope.ltNgModel = !scope.ltNgModel;
      };

      scope.onKeypress = function (event) {
        if (event.key === ' ') {
          // if space key was hit
          scope.toggleValue();
        }
      };
    }
  };
}

App.directive('ltCheckbox', LtCheckboxDirective);
